import { Stack } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import { useLoyaltiesEventsQuery } from "Api/Queries/Loyalty/useLoyaltiesEventsQuery";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { DailyChallenges } from "Components/Loyalty/Shared/Challenges/Categories/DailyChallenges";
import { WeeklyChallenges } from "Components/Loyalty/Shared/Challenges/Categories/WeeklyChallenges";
import { MonthlyChallenges } from "Components/Loyalty/Shared/Challenges/Categories/MonthlyChallenges";
import { LongTermChallenges } from "Components/Loyalty/Shared/Challenges/Categories/LongTermChallenges";
import { UnlimitedChallenges } from "Components/Loyalty/Shared/Challenges/Categories/UnlimitedChallenges";

export const AllChallengesPageContent = () => {
  const { isError } = useLoyaltiesEventsQuery();
  const { t } = useResource();

  if (isError) {
    return (
      <Stack p={3}>
        <ErrorText>{t(Resources.Error.Error)}</ErrorText>
      </Stack>
    );
  }

  return (
    <Stack gap={8} p={3}>
      <DailyChallenges />
      <WeeklyChallenges />
      <MonthlyChallenges />
      <LongTermChallenges />
      <UnlimitedChallenges />
    </Stack>
  );
};
